<template>
  <div>
    <v-row justify="center">
      <v-btn
        v-if="show_btn"
        color="primary"
        class="ma-2"
        dark
        @click="dialog = true"
        >+ 新規登録</v-btn
      >
      <v-dialog v-model="dialog" max-width="800px">
        <loadingDialog :show="loading"></loadingDialog>
        <v-card class="pa-2">
          <v-card-actions>
            <v-card-title>{{ initlabel() }} - {{ name }}登録</v-card-title>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="dialog = false">閉じる</v-btn>
          </v-card-actions>

          <v-card-text>
            <table class="appli_detail" style="width:100%">
              <tr style="display:none;">
                <th>id</th>
                <td class="pl-3">
                  {{ item.id || "自動で採番されます" }}
                </td>
              </tr>

              <tr>
                <th width="60">
                  <span class="red--text">*必須</span>
                </th>
                <td class="pa-3">
                  <v-text-field
                    label="カテゴリ名称"
                    type="text"
                    v-model="item.title"
                  />
                </td>
              </tr>
            </table>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="showDelete()" color="red" text @click="deleteItem()">
              <v-icon>mdi-delete</v-icon>削除
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="save()">
              <v-icon>mdi-content-save</v-icon>保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
/* -----------------------------
   タグの新規登録・更新処理 
------------------------------*/

// Ajax通信ライブラリ
import axios from "axios";
// import loadingDialog from "@/components/Loading";

export default {
  components: {
    // loadingDialog,
  },

  data() {
    return {
      name: "カテゴリ",
      dialog: false,
      item: {},
      loading: false,
      type: "new",
    };
  },

  props: {
    show_btn: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    dialog: function() {
      if (this.dialog && this.type == "new") {
        this.item = {
          id: -1,
          title: "",
                    sort: 0,

          delete_flg: 0,
        };
      }
    },
  },

  methods: {
    editItem(item) {
      this.type = "edit";
      this.item = Object.assign({}, item);
      this.dialog = true;
    },

    newItem() {
      this.type = "new";
      this.dialog = true;
    },

    initlabel() {
      if (this.type == "new") {
        return "新規";
      } else {
        return "編集";
      }
    },

    close() {
      this.dialog = false;
    },

    showDelete() {
      if (this.type == "edit") {
        return true;
      } else {
        return false;
      }
    },

    deleteItem() {
      // var result = confirm("削除しますか？");
      // if (result) {
      //   this.loading = true;
      //   this.item.delete_flg = 1;
      //   const response = this.$axios
      //     .$post(process.env.API_URL + "/label_update", {
      //       data: this.item,
      //     })
      //     .then((response) => {
      //       this.dialog = false;
      //       console.log(response);
      //       this.$emit("itemUpdate", this.item);
      //     })
      //     .catch((error) => {
      //       alert("予期せぬエラーが発生しました");
      //       this.dialog = false;
      //     })
      //     .finally(() => {
      //       this.loading = false;
      //     });
      // }
    },
    save() {
      if (this.item.title.length <= 0) {
        alert("値を入力してください");
        return;
      }

      // this.loading = true;

      var self = this;
      axios
        .post(process.env.VUE_APP_CALENDAR_CATEGORY_UPDATE, {
          data: this.item,
        })
        .then(function(response) {
          self.item.id = response.data.last_id;
          self.$emit("itemCreate", self.item);

          console.log(response);
          self.close();
        });
    },
  },
};
</script>
